// extracted by mini-css-extract-plugin
export default {"imageContainer":"styles_imageContainer__PTkiS","image":"styles_image__iPdWY"};